import * as tslib_1 from "tslib";
import { Container } from "../container";
import { ValueAndUnit } from "../../valueAndUnit";
import { Control } from "../control";
/**
 * Class used to hold a the container for ScrollViewer
 * @hidden
*/

var _ScrollViewerWindow =
/** @class */
function (_super) {
  tslib_1.__extends(_ScrollViewerWindow, _super);
  /**
  * Creates a new ScrollViewerWindow
  * @param name of ScrollViewerWindow
  */


  function _ScrollViewerWindow(name) {
    return _super.call(this, name) || this;
  }

  _ScrollViewerWindow.prototype._getTypeName = function () {
    return "ScrollViewerWindow";
  };
  /** @hidden */


  _ScrollViewerWindow.prototype._additionalProcessing = function (parentMeasure, context) {
    _super.prototype._additionalProcessing.call(this, parentMeasure, context);

    this._measureForChildren.left = this._currentMeasure.left;
    this._measureForChildren.top = this._currentMeasure.top;
    this._measureForChildren.width = parentMeasure.width;
    this._measureForChildren.height = parentMeasure.height;
  };

  _ScrollViewerWindow.prototype._postMeasure = function () {
    var maxWidth = this.parentClientWidth;
    var maxHeight = this.parentClientHeight;

    for (var _i = 0, _a = this.children; _i < _a.length; _i++) {
      var child = _a[_i];

      if (!child.isVisible || child.notRenderable) {
        continue;
      }

      if (child.horizontalAlignment === Control.HORIZONTAL_ALIGNMENT_CENTER) {
        child._offsetLeft(this._currentMeasure.left - child._currentMeasure.left);
      }

      if (child.verticalAlignment === Control.VERTICAL_ALIGNMENT_CENTER) {
        child._offsetTop(this._currentMeasure.top - child._currentMeasure.top);
      }

      maxWidth = Math.max(maxWidth, child._currentMeasure.left - this._currentMeasure.left + child._currentMeasure.width);
      maxHeight = Math.max(maxHeight, child._currentMeasure.top - this._currentMeasure.top + child._currentMeasure.height);
    }

    if (this._currentMeasure.width !== maxWidth) {
      this._width.updateInPlace(maxWidth, ValueAndUnit.UNITMODE_PIXEL);

      this._currentMeasure.width = maxWidth;
      this._rebuildLayout = true;
      this._isDirty = true;
    }

    if (this._currentMeasure.height !== maxHeight) {
      this._height.updateInPlace(maxHeight, ValueAndUnit.UNITMODE_PIXEL);

      this._currentMeasure.height = maxHeight;
      this._rebuildLayout = true;
      this._isDirty = true;
    }

    _super.prototype._postMeasure.call(this);
  };

  return _ScrollViewerWindow;
}(Container);

export { _ScrollViewerWindow };